var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAverageGateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 12.466C6 9.41789 6 7.89384 6.94692 6.94692C7.89385 6 9.41789 6 12.466 6C15.5141 6 17.0381 6 17.9851 6.94692C18.932 7.89384 18.932 9.41789 18.932 12.466C18.932 15.514 18.932 17.0381 17.9851 17.9851C17.0381 18.932 15.5141 18.932 12.466 18.932C9.41789 18.932 7.89385 18.932 6.94692 17.9851C6 17.0381 6 15.514 6 12.466Z",
    stroke: "#172B4D",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.06799 12.5339H19",
    stroke: "#172B4D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2147 9.13086H15.9372",
    stroke: "#2C8C53",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.98165 9.98185C10.4515 9.98185 10.8324 9.60094 10.8324 9.13106C10.8324 8.66118 10.4515 8.28027 9.98165 8.28027C9.51177 8.28027 9.13086 8.66118 9.13086 9.13106C9.13086 9.60094 9.51177 9.98185 9.98165 9.98185Z",
    stroke: "#2C8C53",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.98165 16.788C10.4515 16.788 10.8324 16.4071 10.8324 15.9372C10.8324 15.4673 10.4515 15.0864 9.98165 15.0864C9.51177 15.0864 9.13086 15.4673 9.13086 15.9372C9.13086 16.4071 9.51177 16.788 9.98165 16.788Z",
    stroke: "#2C8C53",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2147 15.9373H15.9372",
    stroke: "#2C8C53",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAverageGateIcon);
export default __webpack_public_path__ + "static/media/average_gate_icon.ec3913a0adea907265aad76120205425.svg";
export { ForwardRef as ReactComponent };